import React, { useState, useEffect } from "react"
import NavProductSubcategory from "../nav-product-subcategory/nav-product-subcategory"
import GridProducts from "../grid-products/grid-products"
import Filter from "../../organisms/filter/filter"
import AsideMobileFilterSubcategory from "../aside-mobile-filter-subcategory/aside-mobile-filter-subcategory"
import BannerSubcategory from "../banner-subcategory/banner-subcategory"
import "./products-list-section.scss"
import { removeDoubleSlash } from "../../../shared/utils/urlUril"

const ProductsListSection = props => {
  const normalize = (function() {
    var from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç",
      to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc",
      mapping = {}

    for (var i = 0, j = from.length; i < j; i++)
      mapping[from.charAt(i)] = to.charAt(i)

    return function(str) {
      var ret = []
      for (var i = 0, j = str.length; i < j; i++) {
        var c = str.charAt(i)
        if (mapping.hasOwnProperty(str.charAt(i))) ret.push(mapping[c])
        else ret.push(c)
      }
      return ret.join("")
    }
  })()

  const {
    currentSubcategory,
    mobile,
    filter,
    setModalActive,
    products,
    currentCategory,
    listAverage,
    infoBannerInterno,
  } = props

  const [listView, setListView] = useState(false)
  const [productsFilter, setProductsFilter] = useState(products)

  const [activeFilters, setActiveFilters] = useState([
    {
      id: 0,
      name: "Borrar Filtros",
      filter: "NA",
      value: false,
    },
  ])

  const filterForTag = (productsFilter, valueFilter) => {
    var itemFilter = valueFilter.nameFilter
    if (itemFilter === "tipoDeToalla" || itemFilter === "tipoDeProtectores") {
      itemFilter = "tipoDeToallaprotector"
    }
    if (itemFilter === "tipo") {
      itemFilter = "aplicador"
    }
    if(itemFilter === "ropaInterior" || itemFilter === "tipoDeActividad" || itemFilter === "flujo"){
      return productsFilter.filter( info => info[itemFilter]?.includes(valueFilter.filter))
      
    }
    return productsFilter.filter(
      info => info[itemFilter] === valueFilter.filter
    )
  }

  const filterFunction = () => {
    var productsFilterAux = products
    for (let i = 1; i < activeFilters.length; i++) {
      if (activeFilters[i].value) {
        productsFilterAux = filterForTag(productsFilterAux, activeFilters[i])
      }
    }
    setProductsFilter(productsFilterAux)
  }



  const handleChangeFilter = (name, filter, index, nameFilter) => {
    nameFilter = nameFilter.split(" ")
    for (let i = 0; i < nameFilter.length; i++) {
      nameFilter[i] =
        nameFilter[i].charAt(0).toUpperCase() + nameFilter[i].slice(1)
    }
    nameFilter = nameFilter.join()
    nameFilter = nameFilter.replace(/,/g, "")
    nameFilter = nameFilter.charAt(0).toLowerCase() + nameFilter.slice(1)
    nameFilter = normalize(nameFilter)
    let item = activeFilters.find(x => x.id === index)
    if (item) {
      if (item.value) {
        item.value = false
      } else {
        item.value = true
      }
    } else {
      activeFilters.push({
        id: index,
        name: name,
        nameFilter: nameFilter,
        filter: filter,
        value: true,
      })
    }

    filterFunction()

    activeFilters[0].value = false
    if (activeFilters.find(x => x.value === true)) {
      activeFilters[0].value = true
    } else {
      activeFilters[0].value = false
    }

    setActiveFilters([...activeFilters])
  }
  return (
    <section className="f-product-list-section-container">
      <h1 className="f-product-list__title">{props.title}</h1>
      <div className="f-backbutton-container">
        <a href={removeDoubleSlash("/productos/" + props.currentCategory)}>
          <label className="f-title-backbutton">
            <span className="f-icon icon-left" /> VOLVER A{" "}
            {props.currentCategory.replace(/-/g, " ").toUpperCase()}
          </label>
        </a>
      </div>
      <div className="f-filter-list-container ">
        <div className={filter ? "f-filter-container" : "f-no-filter"}>
          {filter && (
            <Filter
              currentSubcategory={currentSubcategory}
              filterFunction={filterFunction}
              setProductsFilter={setProductsFilter}
              products={products}
              handleChangeFilter={handleChangeFilter}
              setActiveFilters={setActiveFilters}
              activeFilters={activeFilters}
              filter={filter}
              productTitle= {props.title}
            />
          )}
        </div>
        <div
          className={"f-list-container " + (!filter ? "f-list-no-filter" : "")}
        >
          <div
            className={
              !filter && mobile
                ? "f-list-header-container f-list-header-container-mobile"
                : "f-list-header-container "
            }
          >
            {mobile && filter && (
              <button
                className="f-btn primary-pink-nav-products"
                onClick={() => {
                  setModalActive(
                    <AsideMobileFilterSubcategory
                      mobile={mobile}
                      setModalActive={setModalActive}
                      handleChangeFilter={handleChangeFilter}
                      setActiveFilters={setActiveFilters}
                      activeFilters={activeFilters}
                      filter={filter}
                      productTitle= {props.title}
                    />
                  )
                }}
              >
                Filtrar por
              </button>
            )}
            <NavProductSubcategory
              withFilter={filter}
              currentSubcategory={currentSubcategory}
              setModalActive={setModalActive}
            />
            {!mobile && (
              <div className="f-type-view">
                <div
                  className={"f-button-list-view " + (listView ? "f-pink" : "")}
                  onClick={() => setListView(true)}
                >
                  <span className="line" />
                  <span className="line" />
                </div>
                <div
                  className={
                    "f-button-grid-view " + (!listView ? "f-pink" : "")
                  }
                  onClick={() => setListView(false)}
                >
                  <span className="line-v" />
                  <span className="line-h" />
                </div>
              </div>
            )}
          </div>
          {mobile && filter && (
            <Filter
              currentSubcategory={currentSubcategory}
              filterFunction={filterFunction}
              setProductsFilter={setProductsFilter}
              products={products}
              handleChangeFilter={handleChangeFilter}
              setActiveFilters={setActiveFilters}
              activeFilters={activeFilters}
              filter={filter}
              productTitle= {props.title}
            />
          )}

          <GridProducts
            ctaSubcategoria={props.ctaSubcategoria}
            listAverage={listAverage}
            filter={filter}
            listView={listView}
            currentCategory={currentCategory}
            mobile={mobile}
            products={productsFilter}
            currentSubcategory={currentSubcategory}
          />
        </div>
      </div>
    </section>
  )
}

export default ProductsListSection
